// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"bfd8bd1f","348":"8d34db77","558":"4f32a5c2","571":"2d905589"}[chunkId] + ".chunk.js";
};